module.exports = __webpack_public_path__ + "static/media/jobs.3554a20d.jpg";